import { Color, DefaultValue, Spacing, Text } from '@billy/design-system'
import styled from '@emotion/styled'

interface AnswerWrapperProps {
  isSelected: boolean
}

export const AnswerWrapper = styled.button<AnswerWrapperProps>`
  display: flex;
  align-items: center;
  width: 100%;
  height: 56px;
  margin-bottom: -1px;
  padding: 0 ${Spacing.S24};
  border: 1px solid ${Color.Grey150};
  background: ${Color.White};
  cursor: pointer;

  &:hover {
    background: ${Color.Grey50};
  }

  &:first-of-type {
    margin-top: -1px;
    border-top-left-radius: ${DefaultValue.BorderRadius};
    border-top-right-radius: ${DefaultValue.BorderRadius};
  }
  &:last-of-type {
    border-bottom-right-radius: ${DefaultValue.BorderRadius};
    border-bottom-left-radius: ${DefaultValue.BorderRadius};
  }

  ${({ isSelected }) =>
    isSelected &&
    `
      border-color: ${Color.Green400};
      position: relative;
      z-index: 1;

      &,
      &:hover {
        background: ${Color.Green100};
      }

      ${Letter} {
        &:after {
          background: ${Color.Green400};
        }
      }
    `}
`

// TODO retheming 2026 - get rid of (Text), which is an antipattern
export const Letter = styled(Text)`
  display: flex;
  align-items: center;
  width: 30px;
  margin-right: ${Spacing.S16};
  position: relative;

  &:after {
    content: '';
    width: 1px;
    height: 16px;
    position: absolute;
    right: 0;
    background-color: ${Color.Grey150};
  }
`

// TODO retheming 2026 - get rid of (Text), which is an antipattern
export const Option = styled(Text)``
